<template>
  <div class="d-flex align-items-center">
    <a
      role="button"
      class="tx-16 btn btn-light"
      @click="showChatDrawer"
      style="width: 120px; height: 50px; margin-top: -1px; margin-left: -1px; padding-top: 15px "
    >
      <feather
        :type="drawerShow ? 'x' : 'message-square'"
        class="wd-20-f ht-20-f mg-r-5"
      ></feather
      >Чат
      <span class="msg-ind" v-show="msgCount > 0">{{ msgCount }}</span>
    </a>
    <b-sidebar
      class="zoomSidebar"
      right
      shadow
      v-model="drawerShow"
      :width="`${$store.state.app.isMobile ? '100' : '30'}%`"
      title="Чат"
      no-header
    >
      <header class="b-sidebar-header zoomSidebar-header" style="height: 52px">
        <div class="d-flex justify-content-between">
          <strong id="__BVID__84___title__">Чат.</strong>
          <div
            v-if="zoomUrl != '' && $store.state.app.activeGroup.id != 9254"
            class="mg-l-auto"
          >
            <a
              :href="`${zoomUrl}`"
              class="pd-x-15-f btn btn-uppercase btn-xs btn-primary pd-y-5-f text-white"
              target="_blank"
            >
              <feather type="external-link"></feather>
              Zoom
            </a>
          </div>
          <button
            aria-label="Close"
            class="btn btn-sm pd-x-15 btn-uppercase mg-l-auto btn-danger"
            @click="drawerShow = false"
          >
            <feather type="x" class="mg-r-5"></feather>Хаах
          </button>
        </div>
      </header>
      <embed-team
        v-if="teamId > 0"
        :teamId="teamId"
        :fullheight="true"
      ></embed-team>
    </b-sidebar>
  </div>
</template>
<style scoped>
.msg-ind {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  position: absolute;
  top: -4px;
  right: -8px;
  background-color: #dc3545;
  color: #fff;
  font-size: 10px;
  font-weight: 400;
  font-family: sans-serif;
  line-height: 2;
  border-radius: 100%;
}
</style>
<script>
import { request } from "@/api/all";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
export default {
  components: {
    embedTeam: () => ({
      component: import("@/components/modules/team/embed.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  data() {
    return {
      teamId: 0,
      localTeamId: 0,
      drawerShow: false,
      msgCount: 0,
      zoomUrl: ""
    };
  },
  mounted() {
    request({
      api: { method: "GET", url: "V2/Learn/courseDetailSimple" },
      params: {
        id: this.$route.params.id,
        zoomId: this.$route.params.iid
      },
      store: this.$store
    }).then(res => {
      if (res != false) {
        if (res.data.zoom.url != null) {
          this.zoomUrl = res.data.zoom.url;
        }
        this.localTeamId = res.data.course.teamId;
        this.$store.state.signalr.osrCon.on(
          "v2recieveTeamMessage",
          (date, teamId) => {
            if (this.localTeamId == teamId) {
              if (!this.drawerShow) {
                this.msgCount++;
              }
            }
          }
        );
      }
    });
  },

  methods: {
    showChatDrawer() {
      if (this.drawerShow) {
        this.drawerShow = false;
      } else {
        this.teamId = this.localTeamId;
        this.$nextTick(() => {
          this.msgCount = 0;
          this.drawerShow = true;
        });
      }
    }
  }
};
</script>
